<p-multiSelect 
    [options]="colonnesDisponibles" 
    [(ngModel)]="value"
    optionLabel="entete"
    [selectedItemsLabel]="selectedItemsLabel"
    [style]="style"
    [placeholder]="placeholder"
    (onChange)="onSelectionChange($event)">
    <ng-template pTemplate="header">
        <div class="flex align-items-center justify-content-between px-3 py-2 border-bottom-1 surface-border">
            <span class="font-semibold text-sm">Colonnes</span>
            <button 
                pButton 
                type="button" 
                icon="pi pi-refresh" 
                class="p-button-text p-button-sm p-button-secondary"
                pTooltip="Réinitialiser aux colonnes par défaut"
                tooltipPosition="left"
                (click)="reinitialiserColonnes()">
            </button>
        </div>
    </ng-template>
</p-multiSelect>

